<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-row>
						<b-col lg="4">
							<h2 class="inline-heading">Operación</h2>
						</b-col>
						<b-col lg="8">
							<b-row>
								<b-col md>
									Fecha servicio Desde
									<b-form-datepicker
										:class="{'active-filter':filters.pickupStartDate}"
										reset-button
										size="sm"
										v-model="filters.pickupStartDate"
									/>
								</b-col>
								<b-col md>
									Hasta
									<b-form-datepicker
										:class="{'active-filter':filters.pickupEndDate}"
										reset-button
										size="sm"
										v-model="filters.pickupEndDate"
									/>
								</b-col>
							</b-row>
							<b-row>
								<b-col md>
									<b-form-group label="Aeropuertos">
										<multiselect
											:class="{'active-filter':filters.airport.length>0}"
											v-model="filters.airport"
											:options="airportsOpts"
											group-label="group"
											group-values="options"
											group-select
											multiple
											label="text"
											track-by="value"
											placeholder="Todos"
											:option-height="10"
											taggable
										/>
									</b-form-group>
								</b-col>
								<b-col md>
									<b-form-group label="Destinos">
										<multiselect
											:class="{'active-filter':filters.destination.length>0}"
											v-model="filters.destination"
											:options="destinationsOpts"
											group-label="group"
											group-values="options"
											group-select
											multiple
											label="text"
											track-by="value"
											placeholder="Todos"
											taggable
										/>
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
					<hr>
					<b-button @click="openFilters = !openFilters" variant="info" >Filtros <md-icon :icon="openFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"/> </b-button>
					<b-collapse :visible="openFilters">
						<b-form @submit.prevent="() => { $root.$emit('bv::refresh::table', 'reservations-index-list') } ">
							<b-row>
								<b-form-group class="col-lg-2" label="ID">
									<b-form-input size="sm" :class="{'active-filter':filters.id}" v-model="filters.id" type="number" />
								</b-form-group>
								<b-form-group class="col-lg-2" label="Nombre">
									<b-form-input size="sm" :class="{'active-filter':filters.clientFullName}" v-model="filters.clientFullName" type="text" />
								</b-form-group>
							</b-row>
							<b-row>
								<b-form-group class="col-lg-3" label="Canal de venta">
									<multiselect
										:class="{'active-filter':filters.salesChannel.length>0}"
										v-model="filters.salesChannel"
										:options="salesChannelsOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									/>
								</b-form-group>
								<b-form-group class="col-lg-3" label="Proveedor">
									<multiselect
										:class="{'active-filter':filters.supplier.length>0}"
										v-model="filters.supplier"
										:options="suppliersOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									/>
								</b-form-group>
								<b-form-group class="col-lg-3" label="Tipo de servicio">
									<multiselect
										:class="{'active-filter':filters.serviceType.length>0}"
										v-model="filters.serviceType"
										:options="serviceTypesOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									/>
								</b-form-group>
								<b-form-group class="col-lg-3" label="Estado de servicio">
									<multiselect
										:class="{'active-filter':filters.status.length>0}"
										v-model="filters.status"
										:options="statusOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									/>
								</b-form-group>
							</b-row>
							<b-row>
								<b-form-group class="col-lg-2" label="Tipo de viaje">
									<b-form-select :class="{'active-filter':filters.trip}" size="sm" v-model="filters.trip" :options="tripOpts" />
								</b-form-group>
								<b-form-group class="col-lg-2" label="Estado de contacto">
									<b-form-select :class="{'active-filter':filters.contactStatus}" size="sm" v-model="filters.contactStatus" :options="contactStatusOpts" />
								</b-form-group>
								<b-form-group class="col-lg-3" label="Pickuptime confirmado">
									<b-form-select :class="{'active-filter':filters.pickupDatetimeConfirmed}" size="sm" v-model="filters.pickupDatetimeConfirmed" :options="pickupConfirmedOpts" />
								</b-form-group>
							</b-row>
							<b-collapse id="advanced-options" v-model="computedShowAdvancedOptions">
								<b-row>
									<b-form-group class="col-lg-6" >
										<b-form-row>
											<b-col>
												Fecha creación Desde
												<b-form-datepicker
													:class="{'active-filter':filters.creationStartDate}"
													reset-button
													size="sm"
													v-model="filters.creationStartDate"
												/>
											</b-col>
											<b-col>
												Hasta
												<b-form-datepicker
													:class="{'active-filter':filters.creationEndDate}"
													reset-button
													size="sm"
													v-model="filters.creationEndDate"
												/>
											</b-col>
										</b-form-row>
									</b-form-group>
									<b-form-group class="col-lg-6" >
										<b-form-row>
											<b-col>
												Fecha cancelación Desde
												<b-form-datepicker
													:class="{'active-filter':filters.cancelationStartDate}"
													reset-button
													size="sm"
													v-model="filters.cancelationStartDate"
												/>
											</b-col>
											<b-col>
												Hasta
												<b-form-datepicker
													:class="{'active-filter':filters.cancelationEndDate}"
													reset-button
													size="sm"
													v-model="filters.cancelationEndDate"
												/>
											</b-col>
										</b-form-row>
									</b-form-group>
								</b-row>
							</b-collapse>
							<b-row>
								<b-form-group class="col-lg-3" label="Referencia de Canal">
									<b-form-input size="sm" :class="{'active-filter':filters.salesChannelReference}" v-model="filters.salesChannelReference" type="text" />
								</b-form-group>
								<b-form-group class="col-lg-3" label="Referencia de Proveedor">
									<b-form-input size="sm" :class="{'active-filter':filters.supplierReference}" v-model="filters.supplierReference" type="text" />
								</b-form-group>
								<b-form-group class="col-lg-3" label="Cliente">
									<b-form-checkbox size="sm" v-model="filters.containsEmail" value="yes" unchecked-value="">Tiene email</b-form-checkbox>
									<b-form-checkbox size="sm" v-model="filters.clientEdited" value="yes" unchecked-value="">Edito la reservación</b-form-checkbox>
									<b-form-checkbox size="sm" v-model="filters.clientConfirmed" value="yes" unchecked-value="">Confirmo la reservación</b-form-checkbox>
								</b-form-group>
							</b-row>
							<b-row>
								<b-form-group class="col-lg-12 text-right mt-2" >
									<b-dropdown right text="Exportar XLS" class="mr-2" variant="warning" v-if="$hasPermission('operation.export')">
										<b-dropdown-item @click="() => exportXLS(false)">Sin costos</b-dropdown-item>
										<b-dropdown-item @click="() => exportXLS(true)">Con costos</b-dropdown-item>
									</b-dropdown>
									<b-button @click="filters.showAdvancedOptions = !filters.showAdvancedOptions" variant="info" class="m-2">
										<span v-if="!filters.showAdvancedOptions">Mostrar opciones avanzadas</span>
										<span v-else>Ocultar opciones avanzadas</span>
									</b-button>
									<b-button class="mr-5" @click="filters = {...defaultFilters}; $root.$emit('bv::refresh::table', 'reservations-index-list')" variant="info" >Limpiar</b-button>
									<b-button type="submit" variant="primary" >Buscar</b-button>
								</b-form-group>
							</b-row>
						</b-form>
					</b-collapse>
					<hr>
					<h5>
						<b-badge
							v-for="(aux,i) in $root.auxVars.transportServiceStatusOpts"
							:key="i"
							:variant="aux.class"
							class="mr-2"
							size=""
							>
							{{aux.text}}
						</b-badge>
					</h5>
					<b-row class="my-3">
						<b-form-group  v-if="showSelectAll" class="col-md-8">
							<b-button type="submit" variant="warning" class="mr-2" @click="showAssignSupplierModal">
								<span>Asignar proveedores</span>
							</b-button>
							<b-button type="submit" variant="warning" class="mr-2" @click="showAssignStatusModal">
								<span>Asignar estado</span>
							</b-button>
							<b-button type="submit" variant="warning" class="mr-2" @click="showAssignSupplierConfirmationModal">
								<span>Asignar confirmación de proveedor</span>
							</b-button>
							<b-button type="submit" variant="warning" class="mr-2" @click="showCalculatePickupModal">
								<span>Calculo de pickup</span>
							</b-button>
						</b-form-group>
						<b-form-group  v-if="!showSelectAll" class="col-md-8"></b-form-group>
						<b-form-group class="col-md-4 text-right mt-2" v-if="$hasPermission('operation.massiveOption')" >
							<b-button type="submit" variant="primary" class="mr-2" @click="toggleMassiveAssign">
								<span v-if="!showSelectAll">Habilitar operaciones masivas</span>
								<span v-else>Deshabilitar operaciones masivas</span>
							</b-button>
						</b-form-group>
					</b-row>
					<AjaxTable
						permission-show="operation.show"
						id="reservations-index-list"
						ref="childtable"
						stacked="lg"
						:show-select-all="showSelectAll"
						:selected-items.sync="items"
						:filters="filtersClean"
						:columns="filteredColumns"
						:items-filter="itemsFilter"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						resource="transport-services"
						responsive
					>
						<template #cell(actions)="row">
							<div class="d-flex">
								<b-button @click="(event) => resView(row.item,row.index,event,row.item)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="visibility"></md-icon>
								</b-button>
							</div>
						</template>
						<template #cell(clientName)="row">
							{{row.item.reservation.client.firstName}} {{row.item.reservation.client.lastName}}
						</template>
						<template #cell(clientPhone)="row">
							{{row.item.reservation.client.phone}}
						</template>
						<template #cell(clientEmail)="row">
							{{row.item.reservation.client.email}}
						</template>
						<template #cell(pickup)="row">
							{{row.item.pickup.name}}
						</template>
						<template #cell(dropoff)="row">
							{{row.item.dropoff.name}}
						</template>
						<template #cell(passengers)="row">
							{{row.item.reservation.adults+row.item.reservation.children+row.item.reservation.infants}}
							<!-- ({{row.item.reservation.adults}}.{{row.item.reservation.children}}.{{row.item.reservation.infants}}) -->
						</template>
						<template #cell(serviceType)="row">
							{{row.item.serviceType.name}}
						</template>
						<template #cell(contactStatus)="row">
							{{contactStatusLabels[row.item.contactStatus]}}
						</template>
						<template #cell(netPriceTotal)="row">
							${{row.item.netPriceTotal}}
						</template>
						<template #cell(salesChannel)="row">
							<span style="white-space: nowrap;"><b-badge v-if="row.item.sourceLabel" variant="info" class="ml-1">{{row.item.sourceLabel}}</b-badge> {{row.item.salesChannel.name}}</span>
						</template>
						<template #cell(pickupDatetime)="row">
							<span :class="row.item.pickupDatetimeConfirmed?'text-success text-center':'text-warning text-center'">
								<md-icon :icon="row.item.pickupDatetimeConfirmed ? 'check_circle' : 'warning'"/>
							</span>
							{{row.item.pickupDatetime}}
						</template>
						<template #cell(flightDatetime)="row">
							<span v-if="flightStatusChange(row.item) && row.item.status == 'active'">
								<md-icon icon="flight" variant="success"/>
								<b-spinner variant="warning" small type="grow" />
							</span>
							{{ timeFormat(row.item.flightDatetime) }} / {{row.item.flightNumber}}
						</template>
						<template #cell(supplier)="row">
							<span :class="iconSupplierConfirmation(row.item.supplierConfirmation).class">
								<md-icon  :icon="iconSupplierConfirmation(row.item.supplierConfirmation).icon"/>
							</span>
							{{row.item.supplier.name}}
							<template v-if="row.item.lastRejectedSupplierName">
								<br>Rechazado por: {{row.item.lastRejectedSupplierName}}
							</template>
						</template>
						<template #cell(status)="row">
							{{statusLabels[row.item.status]}}
						</template>
					</AjaxTable>

				</div>
			</div>
			<FormReservation
				:model-id="selected.modalModelId"
				:copy-from-id="selected.copyResId"
				:formTypeWork="formTypeWork"
				@changeId="selected.modalModelId = $event"
				@onCopyRes="copyCurrentRes"
				v-model="form.add"
			/>
			<ImportModal />
			<AssignSuplierModal :selected.sync="itemsObject" />
			<AssignStatusModal :selected.sync="items" />
			<AssignSupplierConfirmationModal :selected.sync="items" />
			<CalculateMassivePickupsModal :selected.sync="items" :res-view="resView"/>
			<vue-snotify />
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import ImportModal from './ImportModal.vue'
import AssignSuplierModal from './AssignSuppliers/AssignSuplierModal'
import AssignStatusModal from './AssignStatusModal.vue'
import AssignSupplierConfirmationModal from './AssignSupplierConfirmationModal.vue'
import CalculateMassivePickupsModal from './CalculateMassivePickupsModal'
import api from '../../../api.js'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

import FormReservation from "../reservation/formReservation/index";

export default {
		components: { MainLayout, FormReservation, ImportModal, AssignSuplierModal, AssignStatusModal, AssignSupplierConfirmationModal, AjaxTable, Multiselect, CalculateMassivePickupsModal },
		data(){
			let defaultFilters = {
				id:'',
				clientFullName:'',
				destination:[],
				salesChannel:[],
				supplier:[],
				airport:[],
				serviceType:[],
				pickupStartDate:'',
				pickupEndDate:'',
				creationStartDate:'',
				creationEndDate:'',
				cancelationStartDate:'',
				cancelationEndDate:'',
				trip:0,
				contactStatus:0,
				status:[{value:'active',text:'Activo'}],
				salesChannelReference: '',
				supplierReference: '',
				containsEmail: '',
				clientEdited: '',
				clientConfirmed: '',
				showAdvancedOptions: false,
				pickupDatetimeConfirmed:null,
				placesWithoutCoordinates:null,
				supplierPriceTotalEmpty:null,
			}
			return {
				items:[],
				itemsObject: [],
				copyResId:-1,
				pendingNotifications: 0,
				exportLoading:false,
				showSelectAll:false,
				modalModelId:-1,
				sortBy: 'pickupDatetime',
				sortDesc: false,
				filters : {...defaultFilters},
				defaultFilters : {...defaultFilters},
				formTypeWork:'newForm',//viewForm -newForm- newFormCopy - newFormLocationReferences
				form: {
					add: false
				},
				selected: {
					modalModelId: -1,
					tsSelectedId: -1,
					copyResId: -1
				},
				modelColumns : [
					{key:'reservationId',label:'Res ID',sortable:true},
					{key:'clientName',label:'Cliente'},
					{key:'pickup',label:'Pickup'},
					{key:'dropoff',label:'Dropoff'},
					{key:'passengers',label:'Pasajeros'},
					{key:'pickupDatetime',label:'Fecha Pickup',sortable:true},
					{key:'flightDatetime',label:'Fecha Vuelo'},
					{key:'serviceType',label:'Tipo servicio'},
					{key:'salesChannel',label:'Canal de venta'},
					// {key:'salesChannelReference',label:'Referencia'},
					{key:'supplier',label:'Proveedor'},
					// {key:'trip',label:'Viaje'},
					// {key:'status',label:'Estado'},
					{key:'contactStatus',label:'Contacto'},
					{key:'netPriceTotal',label:'Costo Venta'},
					{key:'netCurrency',label:'Moneda'},
					{key:'actions',label:'Acciones'},
				],
				pickupConfirmedOpts:[
					{value:null,text:'TODOS'},
					{value:true,text:'CONFIRMADOS'},
					{value:false,text:'NO CONFIRMADOS'},
				],
				openFilters:true,
			}
		},
		computed: {
			filteredColumns(){
				let aux = [];
				if (this.showSelectAll) {
					aux.push({key:'selected',label:''});
				}
				aux = aux.concat(this.modelColumns);
				return aux;
			},
			filtersClean(){
				return {
					id:  this.filters.id,
					clientFullName:  this.filters.clientFullName,
					destination:  this.filters.destination.map(aux => aux.value),
					airport:  this.filters.airport.map(aux => aux.value),
					salesChannel:  this.filters.salesChannel.map(aux => aux.value),
					supplier:  this.filters.supplier.map(aux => aux.value),
					serviceType:  this.filters.serviceType.map(aux => aux.value),
					pickupStartDate: this.filters.pickupStartDate,
					pickupEndDate: this.filters.pickupEndDate,
					creationStartDate: this.filters.creationStartDate,
					creationEndDate: this.filters.creationEndDate,
					cancelationStartDate: this.filters.cancelationStartDate,
					cancelationEndDate: this.filters.cancelationEndDate,
					trip: this.filters.trip,
					contactStatus: this.filters.contactStatus,
					status: this.filters.status.map(aux => aux.value),
					salesChannelReference: this.filters.salesChannelReference,
					supplierReference: this.filters.supplierReference,
					containsEmail: this.filters.containsEmail,
					clientEdited: this.filters.clientEdited,
					clientConfirmed: this.filters.clientConfirmed,
					pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
					placesWithoutCoordinates:this.filters.placesWithoutCoordinates,
					supplierPriceTotalEmpty : this.filters.supplierPriceTotalEmpty,
				}
			},
			destinationsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.destinationsOpts}]
			},
			airportsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.airportsOpts}]
			},
			statusOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.transportServiceStatusOpts}]
			},
			contactStatusOpts(){
				let aux = [...this.$root.auxVars.transportServiceContactStatusOpts]
				aux.unshift({value:0,text:'Todos'})
				return aux
			},
			tripOpts(){
				let aux = [...this.$root.auxVars.tripOpts]
				aux.unshift({value:0,text:'Todos'})
				return aux
			},
			salesChannelsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.salesChannelsOpts}]
			},
			serviceTypesOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.serviceTypesOpts}]
			},
			suppliersOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.suppliersOpts}]
			},
			contactStatusLabels(){
				let vars = this.$root.auxVars.transportServiceContactStatusOpts
				let opts = {}
				for (let i = 0; i < vars.length; i++) {
					opts[vars[i].value] = vars[i].text
				}
				return opts
			},
			statusLabels(){
				let vars = this.$root.auxVars.transportServiceStatusOpts
				let opts = {}
				for (let i = 0; i < vars.length; i++) {
					opts[vars[i].value] = vars[i].text
				}
				return opts
			},
			serviceStatusVariants(){
				let aux = {}
				this.$root.auxVars.transportServiceStatusOpts.map(status => {
					aux[status.value] = status.class
				})
				return aux
			},
			computedShowAdvancedOptions: {
				get() { return this.filters.showAdvancedOptions; },
				set() { }
			}
		},
		methods:{
			copyCurrentRes(){
				this.selected.copyResId = this.selected.modalModelId;
				this.selected.modalModelId = -1;
				this.form.add = true;
			},
			itemsFilter(items){
				return items.map(item => ({
					...item,
					pickupDatetime: moment(item.pickupDatetime).format('DD/MM/YYYY HH:mm'),
					flightDatetime: item.flightDatetime ? moment(item.flightDatetime).format('DD/MM/YYYY HH:mm') : '',
					_rowVariant:this.serviceStatusVariants[item.status]
				}));
			},
			exportXLS(withPrices){
				this.exportLoading = true
				api(this).get(`/transport-services/export`,{
					params:{
						sortBy : this.sortBy,
						sortOrder : this.sortDesc ? 'desc' : 'asc',
						filters : this.filtersClean,
						withPrices: withPrices ? withPrices : null,
					},
					responseType: "blob"
				}).then((res) => {
					let blob = new Blob([res.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					});
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement("a");
					a.href = url;
					a.download = "TransportServices.xlsx";
					a.click();
					window.URL.revokeObjectURL(url);
					this.exportLoading = false
				}).catch(error => {
					this.$root.handleRequestError(error)
					this.exportLoading = false
				});
			},
			resView(item){
				this.selected.copyResId = -1;
				this.selected.modalModelId = item.reservationId;
				this.form.add = true
				//configuramos el estado de formulario formService
				this.formTypeWork="viewForm"
			},
			showAssignSupplierModal() {
				const itemsObject = this.items.map(id => {
					return this.$refs.childtable.data.find(item => item.id === id)
				})
				this.itemsObject = JSON.parse(JSON.stringify(itemsObject))
				setTimeout(()=>{
					this.$root.$emit('bv::show::modal', "modal-assign-supplier-view")
				}, 100)
			},
			showAssignStatusModal() {
				this.$root.$emit('bv::show::modal', "modal-assign-status-view", event.target);
			},
			showAssignSupplierConfirmationModal() {
				this.$root.$emit('bv::show::modal', "modal-assign-supplier-confirmation-view", event.target);
			},
			showCalculatePickupModal() {
				this.$root.$emit('bv::show::modal', "calculate-massive-pickups", event.target);
			},
			toggleMassiveAssign() {
				if (!this.showSelectAll) {
					this.$refs.childtable.showMax();
				}
				this.showSelectAll = !this.showSelectAll;
			},
			iconSupplierConfirmation(status){
				let icon = "";
				let classe = "";
				switch(status){
					case "pending":
						icon   = 'warning'
						classe = 'text-warning'
						break
					case "confirmed":
						icon = 'check_circle';
						classe = 'text-success';
						break;
					case "rejected":
						icon   = 'dangerous'
						classe = 'text-danger'
						break;
				}
				return {icon:icon,class:classe};
			},
			flightStatusChange(item) {
				var flightDatetime       = moment(item.flightDatetime, 'DD/MM/YYYY HH:mm')
				var actualFlightDatetime = moment(item.actualFlightDatetime)

				var minutes = moment.duration(actualFlightDatetime.diff(flightDatetime)).asMinutes()
				if (minutes < 0) { minutes = minutes * -1 }
				if (item.flightValidationStatus == 'api' && item.actualFlightDatetime != null
					&& minutes >= 30) {
					return true
				}
				return false
			},
			dateFormat(val) {
				return moment(val).format('DD/MM/YYYY HH:mm')
			},
			timeFormat(val) {
				return moment(val, 'DD/MM/YYYY HH:mm').format('HH:mm')
			}
		},
		mounted(){
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['suppliersOpts','salesChannelsOpts','serviceTypesOpts','destinationsOpts','airportsOpts']})
			if(localStorage.getItem('reservation-filters')){
				try {
					this.filters = {...this.defaultFilters,...JSON.parse(localStorage.getItem('reservation-filters'))}
				} catch(e) {
					localStorage.removeItem('reservation-filters');
				}
			}
			const today = moment().format("YYYY-MM-DD")
			if (this.filters.pickupStartDate === '') {
				this.filters.pickupStartDate = today
			}
			if (this.filters.pickupEndDate === '') {
				this.filters.pickupEndDate = today
			}
		},
		created(){
			if(localStorage.getItem('reservation-open-filters') !==  null){
				this.openFilters = JSON.parse(localStorage.getItem('reservation-open-filters'))
			}
		},
		watch:{
			openFilters(newVal){
				localStorage.setItem('reservation-open-filters',JSON.stringify(newVal))
			},
			filters:{
				handler(newFilters){
					localStorage.setItem('reservation-filters',JSON.stringify(newFilters))
				},
				deep:true,
			}
		}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style >
	@media (max-width: 600px){
		.box {
			padding: 1em .5em;
		}
		.container{
			padding-left: 8px;
			padding-right: 8px;
		}
	}
	.multiselect__tags{
		max-height: 150px;
		overflow-y: auto;
		overflow-y: auto;
	}
	.active-filter{
		border: 2px solid #021D3E;
	}
	.snotifyToast__title {
		font-size: 1.5em;
	}
	.inline-heading {
		display: inline;
	}
	.inline-button {
		margin-bottom: 10px;
	}
</style>
